// @ts-nocheck
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Breadcrumb from '../../components/breadcrumb/breadcrumb';
import Pagination from '../../components/pagination/Pagination';
import DeleteModalPartner from './DeleteModalPartner';
import { URL } from '../../service/Service';
import ErrorMessage from '../../components/ErrorMessage';
import { ArrowRightIcon, MagnifyingGlassIcon, PlusIcon, UsersIcon } from '@heroicons/react/24/outline';
import { useTranslation } from '../../i18n/LanguageContext';

export const TablePartner = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [originalPeople, setOriginalPeople] = useState([]);
  const [peopleData, setPeopleData] = useState(originalPeople);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const pages = [{ name: t('partners.breadcrumb'), href: '/admin/parceiros', current: true }];

  useEffect(() => {
    const getPartners = async () => {
      const jwtToken = sessionStorage.getItem("jwt");
      try {
        const res = await axios.get(`${URL}/api/partners`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setOriginalPeople(res.data);
        setPeopleData(res.data);
      } catch (error) {
        console.error(error);
        setError(error);
      }
    };

    getPartners();
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = peopleData.slice(indexOfFirstPost, indexOfLastPost);

  const handleChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setSearchTerm(searchTerm);

    let filteredData = originalPeople;
    if (searchTerm) {
      filteredData = originalPeople.filter((data) => {
        return (
          data.name.toLowerCase().includes(searchTerm) ||
          data.nif.toLowerCase().includes(searchTerm)
        );
      });
    }

    setPeopleData(filteredData);
  };

  const handleDelete = async (partnerID) => {
    const jwtToken = sessionStorage.getItem("jwt");
    try {
      await axios.delete(`${URL}/api/partners/${partnerID}`, {
        headers: {
          'Authorization': `Bearer ${jwtToken}`
        }
      });
      setPeopleData(prevPeopleData => prevPeopleData.filter(person => person.partnerID !== partnerID));
      setOriginalPeople(prevPeopleData => prevPeopleData.filter(person => person.partnerID !== partnerID));
      return true;
    } catch (error) {
      console.error(error);
      setError(error);
      return false;
    }
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Container fluid className="portal-page">
      {error && <ErrorMessage message={t('partners.loadError')} />}
      <Breadcrumb pages={pages} />

      <header className="portal-page-header">
        <div className="portal-page-heading">
          <span className="portal-eyebrow">Backoffice Eupago</span>
          <h1>{t('partners.title')}</h1>
          <p>
            {t('partners.description')}
          </p>
        </div>
        <Link to="/admin/criar-parceiro" className="portal-button portal-button-primary">
          <PlusIcon />
          {t('partners.new')}
        </Link>
      </header>

      <section className="portal-panel">
        <div className="portal-toolbar">
          <div className="portal-search">
            <MagnifyingGlassIcon aria-hidden="true" />
            <input
            type="text"
            placeholder={t('partners.search')}
            onChange={handleChange}
            value={searchTerm}
          />
          </div>
          <span className="portal-result-count">{peopleData.length} {t('nav.partners').toLowerCase()}</span>
        </div>

        <div className="portal-table-wrap">
          <table className="portal-table">
            <thead>
  <tr>
    <th scope="col" className="portal-action-column">
      <span className="sr-only">{t('common.delete')}</span>
    </th>
    <th scope="col">
      {t('partners.name')}
    </th>
    <th scope="col">
      Email
    </th>
    <th scope="col">
      NIF
    </th>
    <th scope="col" className="portal-table-actions">
      <span className="sr-only">{t('partners.more')}</span>
    </th>
  </tr>
</thead>

              <tbody>
                {currentPosts.map((person) => (
                  <tr key={person.partnerID}>
                    <td className="portal-action-column">
                        <DeleteModalPartner
                          partnerID={person.partnerID}
                          partnerName={person.name}
                          handleDelete={handleDelete}
                        />
                    </td>
                    <td data-label={t('partners.name')}>
                      <span className="portal-cell-primary">{person.name}</span>
                    </td>
                    <td data-label="Email">
                      <span className="portal-cell-muted">{person.email}</span>
                    </td>
                    <td data-label="NIF"><span className="portal-code">{person.nif}</span></td>
                    <td className="portal-table-actions">
                        <button
                          onClick={() => { window.location.href = `/admin/parceiros/${person.partnerID}/edit`; }}
                          className="portal-button portal-button-secondary portal-button-compact"
                        >
                          <span>{t('partners.more')}</span>
                          <ArrowRightIcon />
                        </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {currentPosts.length === 0 && (
              <div className="portal-empty-state">
                <UsersIcon />
                <strong>{t('partners.loadError')}</strong>
              </div>
            )}
        </div>

        <footer className="portal-panel-footer">
          <Pagination
            postsPerPage={postsPerPage}
            totalPosts={peopleData.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </footer>
      </section>
    </Container>
  );
};

export default TablePartner;
